import React from 'react';
import { Box, Paper, Typography, Avatar } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';

interface StatCardProps {
    title: string;
    value: string | number;
    percentChange?: string;
    changeColor?: string; // e.g., 'green', 'red'
    subtitle?: string;
    icon: React.ReactNode;
    sx?: SxProps<Theme>;
    to: string
}

const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    percentChange,
    changeColor = 'green',
    subtitle = 'vs. last month',
    icon,
    sx,
    to
}) => {
    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                borderLeft: '4px solid !important',
                border: '1px solid',
                borderRadius: '12px !important',
                // background: 'linear-gradient(to bottom right, #ebf8ff, #f3e8ff)',
                boxShadow: '5px 5px 15px #d9d9d9, -5px -5px 15px #ffffff',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                    boxShadow: 6,
                },
                ...sx,
            }}
        >
            <Link to={to}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="body2" color="text.secondary">
                            {title}
                        </Typography>
                        <Typography variant="h5" fontWeight="bold" mt={1}>
                            {value}
                        </Typography>
                        {percentChange && (
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <Typography variant="body2" sx={{ color: changeColor }}>
                                    {percentChange}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {subtitle}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Avatar
                        sx={{
                            color: (theme: any) => theme.palette.primary.main,
                            backgroundImage: (theme: any) => `linear-gradient(135deg, ${alpha(theme.palette.primary.lighter, 0)} 0%, ${alpha(theme.palette.primary.lighter, 0.24)} 100%)`,
                            width: 56,
                            height: 56,
                        }}
                    >
                        {icon}
                    </Avatar>
                </Box>
            </Link>
        </Paper>
    );
};

export default StatCard;
